import React from "react";
import ModalShell from "./ModalShell";

export default function LogoutConfirmDialog({ open, onCancel, onConfirm }) {
  return (
    <ModalShell open={open} title="Log out?" subtitle="Account" onClose={onCancel} maxWidthClass="max-w-sm">
      <p className="text-sm leading-relaxed text-slate-600">
        Are you sure you want to log out? You’ll need to sign in again to access your account.
      </p>
      <div className="mt-6 grid grid-cols-2 gap-3">
        <button type="button" onClick={onCancel}
          className="rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
          Cancel
        </button>
        <button type="button" onClick={onConfirm}
          className="rounded-xl bg-slate-950 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
          Log out
        </button>
      </div>
    </ModalShell>
  );
}
